<template>
    <div class="box">
        <div class="top">
            <div class="text">
                <h4>{{title[switchindex]}}</h4>
                <p v-html="content[switchindex]"/>
            </div>
        </div>
        <div class="notice-wrapper">
                <div class="container lines" id="lines">

                    <ul class="other-ul send">
                        <li>
                            <a href="javascript:void(0)" @click="switchindex=0">
                                <i class="iconfont icon-icon-sfg"></i>
                                <p>一件代发</p>
                            </a>
                        </li>
                        <li>
                            <a href="javascript:void(0)" @click="switchindex=1">
                                <i class="iconfont icon-icon-hz"></i>
                                <p>集运转运</p>
                            </a>
                        </li>
                    </ul>
            </div>
        </div>
<div class="notice-wrapper overflow">
            <h2 class="ntitle">{{title[switchindex]}}</h2>
            <div class="row">
                <div class="col-md-6">
                <a href="javascript:void(0)" class="news-col">
                <img src="~@/images/yf.jpg">
                <div class="infos">
                    <h2>商品限制</h2>
                    <p v-for="(item,index) in spxz[switchindex]" :key="index">
                        {{item}}
                    </p>
                </div>
                </a>
            </div>
            <div class="col-md-6">
                <a href="javascript:void(0)" class="news-col">
                <img src="~@/images/qy.jpg">
                <div class="infos">
                    <h2>服务地域</h2>
                    <p v-for="(item,index) in fwdy[switchindex]" :key="index">
                        {{item}}
                    </p>
                </div>
                </a>
            </div>
            <div class="col-md-6">
                <a href="javascript:void(0)" class="news-col">
                <img src="~@/images/fw.jpg">
                <div class="infos">
                    <h2>服务内容</h2>
                    <p v-for="(item,index) in fwnr[switchindex]" :key="index">
                        {{item}}
                    </p>
                </div>
                </a>
            </div>
            <div class="col-md-6">
                <a href="javascript:void(0)" class="news-col">
                <img src="~@/images/sx.jpg">
                <div class="infos">
                    <h2>时效</h2>
                    <p v-for="(item,index) in sx[switchindex]" :key="index">
                        {{item}}
                    </p>
                </div>
                </a>
            </div>
            <div class="col-md-6">
                <a href="javascript:void(0)" class="news-col">
                <img src="~@/images/zengzhi.jpg">
                <div class="infos">
                    <h2>增值服务</h2>
                    <p v-for="(item,index) in zzfw[switchindex]" :key="index">
                        {{item}}
                    </p>
                </div>
                </a>
            </div>

            <div class="col-md-6">
                <a href="javascript:void(0)" class="news-col">
                <img src="~@/images/gj.jpg">
                <div class="infos">
                    <h2>订单轨迹</h2>
                    <p v-for="(item,index) in ddgj[switchindex]" :key="index">
                        {{item}}
                    </p>
                </div>
                </a>
            </div>
          </div>
        </div>

        <div class="notice-wrapper">
            <h2 class="ntitle">快速咨询发货</h2>

            <div class="wx">
                <div class="wxitem wxitem1">
                    <p>产品介绍微信</p>
                    <img src="/static/images/wj.png"/>
                </div>
                <!-- <div class="wxitem">
                    <p>销售咨询微信</p>
                    <img src="/static/images/mq.png"/>
                </div> -->
            </div>
        </div>

    </div>
</template>
<script>

export default {
  name: 'warehouse',
  data () {
    return {
      switchindex: 0,
      content: [
        '1.仓库设有大型自动化处理设备<br/>2.拥有自主研发的运营系统，实现国内全自动分拣<br/>3.提升库内处理效率，加快国外派送时效<br/>4.专业的仓储物流系统，提供一件代发服务。',
        '1V1对接服务<br/>免费代收、免费拆包、免费仓库、免费验货、免费拍照'
      ],
      title: ['一件代发', '集运转运'],
      spxz: [
        ['是否支持带电:是', '重量限制:30KG', '体积限制:0.23m³', '尺寸限制:各边长≤150cm'],
        ['是否支持带电:是', '重量限制:30KG', '体积限制:0.23m³', '尺寸限制:各边长≤150cm']],
      fwdy: [
        ['欧洲：英国、德国、意大利、法国', '美洲：美国、加拿大', '澳洲:澳大利亚'],
        ['欧洲：英国、德国、意大利、法国', '美洲：美国、加拿大', '澳洲:澳大利亚']
      ],
      fwnr: [
        ['送货到行运易, 定制化服务, 个性化服务, 上架库存，客户可随时监控库存'],
        ['私信获取仓库地址、物品寄到XYY仓库，物品到齐后打包，支付运费并发货']
      ],
      sx: [
        ['入库到发货:24-48H'],
        ['入库到发货:24-48H']
      ],
      zzfw: [
        ['增值服务:SKU粘贴/更换', '库存盘点'],
        ['增值服务:无']
      ],
      ddgj: [
        ['是否可查：是'],
        ['是否可查：是']
      ]
    }
  },
  created () {
    this.switchindex = this.$route.query.id ? this.$route.query.id : 0
  }
}
</script>
<style scoped>

    .wx {
        background:#fff;
        border:1px solid #ebeeee;
        padding: 3px 3px 0 3px;
        background: #fff;
        width: 1300px;
        height:280px;
        text-align: center;
        padding:40px;
        -webkit-box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);
        box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);
        box-sizing: border-box;
    }
     .wxitem img{
        max-width: 200px;
        max-height: 200px;
     }
    .wxitem{
        width:45%;
    margin-right:30px;
    float: left;
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;

    }
    .wxitem1 {
      float: none;
      margin: 0 auto;
    }

*{font-weight: 400;}
body, ul, ol, li, p, h1, h2, h3, h4, h5, h6, form, fieldset, table, td, img, div, dl, dt, dd, input {
    margin: 0;
    padding: 0;
}
.ntitle{
    text-align: center;
    margin-bottom:40px;
    font-size: 42px;
}
.row{
    margin-right: -15px;
    margin-left: -15px;
}
.col-md-6 {
    width: 50%;
    /* margin-right:30px; */
    float: left;
    position: relative;
    min-height: 1px;
    padding-right: 30px;
    padding-left: 15px;
    box-sizing: border-box;
}
 .news-col {
    margin-bottom: 34px;
    position: relative;
    -webkit-box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);
    box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    padding: 16px 0px 16px 16px;
    background: #fff;
    text-decoration: none;
    color: #666;
    height:170px;
 }
 .news-col .infos p {
    font-size: 13px;
    color: #999;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 2px 0;
    position: relative;
}
 .news-col .infos h2 {
    margin-top:0;
    font-size: 22px;
    color: #333;
    line-height: 22px;
    margin-bottom: 13px;
}
.news-col img {
    width: 260px;
    height: auto;
    overflow: hidden;
}
  .news-col .infos {
    padding: 4px 0 4px 16px;
    display: block;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
}
.news-col .infos h2 {
    font-size: 22px;
    color: #333;
    line-height: 22px;
    margin-bottom: 13px;
}
.container {
    background: #fff;
    top: -40px;
    position: relative;
    border-radius: 6px;
    padding: 16px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);
    box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);
    z-index: 9;
}
.overflow {
    overflow: hidden;
}
.notice-wrapper .other-ul li a p {
    font-size: 14px;
    padding-top: 6px;
    margin:0
}
.notice-wrapper {
    position: relative;
    width: 1300px;
    margin:0 auto;
    box-sizing: border-box;
}
.notice-wrapper .other-ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.notice-wrapper .other-ul li {
    width: 25%;
    text-align: center;
    list-style: none;
}
.notice-wrapper .other-ul li a {
    display: inline-block;
    padding: 0 10px;
    text-decoration: none;
    color: #666;
}
.notice-wrapper .other-ul li a i {
    color: #fff;
    font-size: 34px;
    border-radius: 50%;
    height: 50px;
    line-height: 50px;
    display: inline-block;
    width: 50px;
    background: #E7E7E7;
    background: -webkit-gradient(linear, left top, left bottom, from(#005ADC), to(#1C77FA));
    background: linear-gradient(#005ADC, #1C77FA);
    -webkit-box-shadow: 2px 2px 14px rgb(0 90 220 / 30%);
    box-shadow: 2px 2px 14px rgb(0 90 220 / 30%);
}
    .top
    {
        background:url(~@/images/warehouseBg.jpg);background-repeat: no-repeat;background-position-x: center; background-position-y: center;
        width:100%;
        height: 315px;
    }
.text{
    width:1260px;
    padding-top: 45px;
    padding-left:40px;
    margin:0 auto;
}
.text h4{
        color: #333;
    margin-bottom: 12px;
    font-size: 24px;
}
.text p{
    width: 460px;
    color: #333;
        font-size: 14px;
        margin: 10px 0;
    line-height: 22px;
}

    .center{
        width:1300px;
        box-sizing: border-box;
        padding:50px 50px 100px 50px;
        min-height: 800px;
        background-color: #ffffff;
        border-radius: 5px;
        margin:0 auto;
        margin-top:-40px;
    }

    .tag{
        display: inline-block;
        background-color: #004c73;
        border-radius: 100px 35px 35px 100px;
        padding: 8px 18px 8px 35px;
        margin-right: 10px;
        position: relative;
    }

    .tag p
    {
        font-size: 14px;
        color: #fff;
        margin: 0;
        border:none;
    }
    .tag p:before{
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #fff;
        position: absolute;
        left: 10px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .box{margin-bottom: 50px;;}
</style>



// WEBPACK FOOTER //
// src/components/warehouse.vue